export const makeSortGroups = (sortBy, sortOrder) => (a, b) => {
  switch (sortBy) {
    case 'id': {
      if (sortOrder === 'ascending') {
        return a.id - b.id
      } else {
        return b.id - a.id
      }
    }

    case 'members': {
      if (sortOrder === 'ascending') {
        return a.permissions.length - b.permissions.length
      } else {
        return b.permissions.length - a.permissions.length
      }
    }

    case 'name': {
      if (sortOrder === 'ascending') {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      } else {
        return b.name.toLowerCase().localeCompare(a.name.toLowerCase())
      }
    }

    case 'permissions': {
      if (sortOrder === 'ascending') {
        return a.permissions.length - b.permissions.length
      } else {
        return b.permissions.length - a.permissions.length
      }
    }

    default:
      return new Date(b.updatedAt) - new Date(a.updatedAt)
  }
}
